import { render } from "./readBookInfo.vue?vue&type=template&id=55fe0fbb&scoped=true"
import script from "./readBookInfo.vue?vue&type=script&lang=js"
export * from "./readBookInfo.vue?vue&type=script&lang=js"

import "./readBookInfo.vue?vue&type=style&index=0&id=55fe0fbb&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fe0fbb"]])

export default __exports__